// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__b_SjD","buttons":"SendReceipts_buttons__10Giz","email":"SendReceipts_email__Bl5UU","bookApptTitle":"SendReceipts_bookApptTitle__3vj5z"};